import React from "react"
import { Box } from "rebass"
import PropTypes from "prop-types"
import LinkAnimated from "./LinkAnimated"

const RouteLink = ({ children }) => {
  return (
    <Box mb={0} pt={(3, 4)} fontSize={[1, 2, 3]}>
      <LinkAnimated>{children}</LinkAnimated>
    </Box>
  )
}

RouteLink.propTypes = {
  children: PropTypes.node,
}

export default RouteLink
